import { useContext } from "react";
import { UpdateExperiencePackageContext } from "./UpdateExperiencePackageContext";

const useUpdateExperiencePackageContext = () => useContext(UpdateExperiencePackageContext);

export default useUpdateExperiencePackageContext;
